import { MIN_CRITERIA_LENGTH } from "@/constants";

import styles from "./HighlightText.module.scss";

interface HighlightTextProps {
  text: string;
  criteria: string;
  fullText: string;
}

export const HighlightText = ({
  text,
  criteria,
  fullText,
}: HighlightTextProps) => {
  const highlightText = () => {
    const regex = new RegExp(`(${criteria})`, "gi");
    const parts = text.split(regex);
    return parts.map((part, index) =>
      part.toLowerCase() === criteria.toLowerCase() ? (
        <span key={index} className={styles.highlight}>
          {part}
        </span>
      ) : (
        part
      ),
    );
  };

  return (
    <span title={fullText}>
      {criteria.length < MIN_CRITERIA_LENGTH ? text : highlightText()}
    </span>
  );
};
